import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    getEmploiInformationInscritesRequest: ['response'],
    getEmploiInformationInscritesSuccess: ['response', 'loading'],
    getEmploiInformationInscritesFailure: ['error'],
})

export const getEmploiInformationInscritesTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const getEmploiInformationInscritesSuccess = (state, { response }) =>
    state.merge({
        error: false,
        response,
        loading: false,
    })
const getEmploiInformationInscritesFailure = (state, { error }) =>
    state.merge({
        loading: false,
        error,
    })
const getEmploiInformationInscritesRequest = state =>
    state.merge({ loading: true, error: null })

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_EMPLOI_INFORMATION_INSCRITES_REQUEST]: getEmploiInformationInscritesRequest,
    [Types.GET_EMPLOI_INFORMATION_INSCRITES_SUCCESS]: getEmploiInformationInscritesSuccess,
    [Types.GET_EMPLOI_INFORMATION_INSCRITES_FAILURE]: getEmploiInformationInscritesFailure,
})
